module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/reservation@2x-dc754f0150131de4148547345927fc8b.webp";